var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.5 0 0.5 0.5 0.5 4V13.5C0.5 15.43 2.07 17 4 17L2.85 18.15C2.54 18.46 2.76 19 3.21 19H4.3C4.43 19 4.56 18.95 4.65 18.85L6.5 17H10.5L12.35 18.85C12.44 18.94 12.57 19 12.7 19H13.79C14.24 19 14.46 18.46 14.14 18.15L13 17C14.93 17 16.5 15.43 16.5 13.5V4C16.5 0.5 12.5 0 8.5 0ZM4 15C3.17 15 2.5 14.33 2.5 13.5C2.5 12.67 3.17 12 4 12C4.83 12 5.5 12.67 5.5 13.5C5.5 14.33 4.83 15 4 15ZM7.5 8H2.5V4H7.5V8ZM13 15C12.17 15 11.5 14.33 11.5 13.5C11.5 12.67 12.17 12 13 12C13.83 12 14.5 12.67 14.5 13.5C14.5 14.33 13.83 15 13 15ZM14.5 8H9.5V4H14.5V8Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainIcon);
export default __webpack_public_path__ + "static/media/TrainIcon.7e19f42ecac4bd385d86e730e16935e3.svg";
export { ForwardRef as ReactComponent };